export default function BrandMark({ size = 36, className = "", showWordmark = false }) {
  return (
    <span className={`inline-flex items-center gap-3 ${className}`} data-testid="brand-mark">
      <img
        src="/brand/cauldron-icon.png"
        alt="Cauldron"
        width={size}
        height={size}
        className="select-none"
        style={{ width: size, height: size, objectFit: "contain" }}
        draggable={false}
      />
      {showWordmark && (
        <span className="font-serif tracking-wide text-primary" style={{ fontSize: Math.round(size * 0.85) }}>
          cauldron
        </span>
      )}
    </span>
  );
}
